// Note Model
cv.Note =  Backbone.RESTModel.extend({
  defaults : {
  },

  saveMap : {
    'body' : 'body'
  },

  urlRoot: function(){
    return cv.api_path + '/notes';
  },

  initialize: function(){
    console.log('Note model initialized.');
  }
});
Cocktail.mixin(cv.Note, cv.mixins.SyncModel);

// Notes Collection
cv.Notes = Backbone.Collection.extend({
  initialize: function(options){
    console.log('Note collection initialized.');
  },

  url: function() {
    return cv.api_path + "/notes?" + $.param(this.params);
  },

  model: cv.Note
});
Cocktail.mixin(cv.Notes, cv.mixins.PaginateModel);
